<template>
  <div>
    <button
      v-if="!loading"
      class="btn green margin-bottom-10"
      @click="showAddFormModal = true">
      Add New
    </button>
    <base-form-index
      :loading="loading"
      :rows="rows"
      :columns="columns"
      @form-removed="fetchParticipantForms"
    />

    <add-form-modal v-if="showAddFormModal"
                    v-on:hide="showAddFormModal = false"
                    :modules="modules"/>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import BaseFormIndex from "./BaseFormIndex";
import AddFormModal from "../modals/AddFormModal";

export default {

  components: {
    AddFormModal,
    BaseFormIndex,
  },

  data() {
    return {
      columns: [
        {
          label: 'Related To',
          field: 'module_name',
          filterOptions: {enabled: true}
        },
        {
          label: 'Name',
          field: 'name',
          html: true,
          filterOptions: {enabled: true}
        },
        {
          label: 'Description',
          field: 'description',
          filterOptions: {enabled: true}
        },
        {
          label: 'Status',
          field: 'publish',
          filterOptions: {enabled: true}
        },
        {
          label: 'Created By',
          field: 'created_date',
          filterOptions: {enabled: true}
        },
        {
          label: 'Last Modified',
          field: 'last_modification_date',
          filterOptions: {enabled: true}
        },
        {
          label: 'Actions',
          field: 'actions',
          sortable: false,
        }
      ],
      showAddFormModal: false,
    }
  },

  computed: {
    ...mapGetters({
      'loading': 'getParticipantFormsLoading',
      'forms': 'getParticipantForms',
      'modules': 'getParticipantFormsModules',
      'user': 'getUser'
    }),
    rows() {
      let rows = [];
      Object.entries(this.forms).forEach(([key, row]) => {

        let date = this.$options.filters.formatDate(row.created_date.date);
        row.created_date = row.user + ' on ' + date;

        if (row.last_modification_date) {
          date = this.$options.filters.formatDate(row.last_modification_date);
        }

        if (row.last_action_user) {
          row.last_modification_date = row.last_action_user + ' on ' + date;
        }
        rows.push(row);
      });

      return rows;
    }
  },

  mounted() {
    if (this.user.organizations[0].accountType == 'program') {
      this.columns.splice(4, 0, {
        label: 'Programs',
        field: 'programs_str',
        filterOptions: {enabled: true}
      });
    }
    this.fetchParticipantForms();
  },

  methods: {
    ...mapActions([
      'fetchParticipantForms'
    ]),
  },
}
</script>



// WEBPACK FOOTER //
// ParticipantFormsIndex.vue?30cf7748